const firebaseConfig = {
  apiKey: "AIzaSyA8pLsQIjLc8jeQRxh354_UVaSgbW-l-rw",
  authDomain: "food-devlivery-app.firebaseapp.com",
  databaseURL: "https://food-devlivery-app.firebaseio.com",
  projectId: "food-devlivery-app",
  storageBucket: "food-devlivery-app.appspot.com",
  messagingSenderId: "295524115880",
  appId: "1:295524115880:web:79a2e6d408d54dd28be99d",
  measurementId: "G-B6K2G5PR29",
};

export default firebaseConfig;
